<template>
	<v-dialog v-model="dialogModel" max-width="730px" max-height="386px" persistent>
		<v-card>
			<v-card-title class="text-h6">{{ $t('absence.confirm_delete_message') }}</v-card-title>
			<v-card-text>
				<div class="field-group-label">{{ $t('add_comment') }}</div>
				<v-textarea v-model="changeComment" dense auto-grow rows="4" hide-details :placeholder="$t('userGroups.write')" variant="underlined" />
			</v-card-text>
			<v-card-actions class="px-4 py-3">
				<v-spacer></v-spacer>
				<v-btn text @click="handleCancel">{{ $t('action_cancel') }}</v-btn>
				<v-btn text color="#10565C" :loading="loading" @click="handleConfirm">{{ $t('action_delete') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';

defineOptions({
	name: 'AbsenceDeleteConfirmDialog',
});

defineProps({
	loading: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['cancel', 'confirm']);

const dialogModel = defineModel({ type: Boolean, default: false });

const changeComment = ref('');

watch(dialogModel, (isOpen) => {
	if (!isOpen) {
		changeComment.value = '';
	}
});

function handleCancel() {
	emit('cancel');
	dialogModel.value = false;
}

function handleConfirm() {
	emit('confirm', changeComment.value);
}
</script>
